import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

export const getInvestmentProductRate = async ({
  investRateId,
  enteredPrincipalAmount,
  tenure,
  tenantId,
}) => {
  let queryParam = `?ProductId=${investRateId}&Amount=${enteredPrincipalAmount}&Tenure=${tenure}&TenantId=${tenantId}`;
  const data = await getData(
    `${ajaxEndpoints.INVESTMENT_PRODUCT_RATE}${queryParam}`
  );
  return data?.data;
};

export default function useInvestmentProductRate({
  investRateId,
  enteredPrincipalAmount,
  tenure,
  tenantId,
}) {
  return useQuery(
    [
      {
        investRateId,
        enteredPrincipalAmount,
        tenure,
        tenantId,
      },
      "getInvestmentProductRate",
    ],
    getInvestmentProductRate,
    {
      enabled:
        investRateId !== null &&
        enteredPrincipalAmount !== "" &&
        tenure !== "" &&
        tenure.length > 1,
    }
  );
}
